module.exports = __webpack_public_path__ + "media/img/payments/payment-illustration-1-73d27c6bafc9f0786e810cd0cbd47e6a.svg";